const DROPDOWN_PRICE_FIELD_MAP = {
  oneTime: 'oneTimePrice',
  threeYearEasyPayment: 'threeYearEasyPayment',
  fiveYearEasyPayment: 'fiveYearEasyPayment'
};

/**
 * Resolves price fields from a dropdown value and its options.
 * @param {string} value - Selected value (e.g. 'oneTime', 'threeYearEasyPayment', 'fiveYearEasyPayment')
 * @param {Array} dropdownOptions - Options array (items with .fields.value/.fields.price or .value/.price)
 * @returns {{ oneTimePrice: number|'', threeYearEasyPayment: number|'', fiveYearEasyPayment: number|'' }}
 */
export const getDropdownPricingFromValue = (value, dropdownOptions) => {
  const options = dropdownOptions || [];
  const selectedOption = options.find(opt => {
    const optValue = (opt.fields && opt.fields.value) || opt.value;
    return optValue === value;
  });
  const price = selectedOption
    ? Number((selectedOption.fields && selectedOption.fields.price) || selectedOption.price || 0)
    : 0;

  const result = {
    oneTimePrice: '',
    threeYearEasyPayment: '',
    fiveYearEasyPayment: ''
  };
  if (DROPDOWN_PRICE_FIELD_MAP[value]) {
    result[DROPDOWN_PRICE_FIELD_MAP[value]] = price;
  }
  return result;
};
